/** Aviso anti-dedazo de fechas (caso Michell Open 2026-07-30: el torneo
 * traía inicio 29/06 en vez de 29/07 y el link público llevaba un mes
 * cerrado "sin razón"). Si el torneo figura como iniciado en el pasado, el
 * admin lo ve JUNTO al link público con la fecha exacta y los días. */

function formatoDdMmAaaa(iso: string): string {
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
}

export function tournamentStartNotice(
  startDateIso: string | null | undefined,
  todayIso: string,
  /** "datos" = el aviso se pinta junto al campo de fecha (Cowork 2026-09-18:
   * salía solo en Inscripciones y no donde se corrige). */
  where: "inscripciones" | "datos" = "inscripciones",
): { days: number; message: string } | null {
  if (!startDateIso || !todayIso) return null;
  const start = Date.parse(`${startDateIso}T00:00:00`);
  const today = Date.parse(`${todayIso}T00:00:00`);
  if (!Number.isFinite(start) || !Number.isFinite(today)) return null;
  const days = Math.round((today - start) / 86_400_000);
  if (days <= 0) return null;
  const cuanto = days === 1 ? "1 día" : `${days} días`;
  const base = `Este torneo figura como iniciado hace ${cuanto} (inicio: ${formatoDdMmAaaa(startDateIso)}); el link público se cierra desde el día siguiente al inicio.`;
  if (days >= 7) {
    return {
      days,
      message:
        where === "datos"
          ? `${base} ¿Dedazo de mes o de año? Corrígela aquí mismo y guarda.`
          : `${base} ¿Dedazo de mes o de año? Corrige la fecha en Datos del torneo.`,
    };
  }
  return { days, message: base };
}
